import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
// checks if the user is logged in to determine what to display 
  isLogged() {
    return localStorage.token != null 
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/navbar/navbar.component.ts